import Resources from 'components/MapPage/CorporateViewTabs/Resources';
export const InitialResponseResources: React.FC = () => {
  return <Resources forceFullView />;
};
